import {AuthStorage} from '@/packages/auth/AuthStorage';
import config from '@/config';

const TOKEN_STORAGE_NAME = config.auth.tokenName;

export default <AuthStorage>{
  get(): string | null | undefined {
    return localStorage.getItem(TOKEN_STORAGE_NAME);
  },
  save(token: string) {
    localStorage.setItem(TOKEN_STORAGE_NAME, token);
  },
  remove() {
    localStorage.removeItem(TOKEN_STORAGE_NAME);
  },
  exists() {
    return !!this.get();
  },
};
